// extracted by mini-css-extract-plugin
export default {"fsOutOfStock":"out-of-stock-module--fs-out-of-stock--0690f"};